const sidebarResourceReducer = (state = {}, action) => {
    switch (action.type) {
        case 'GET_SIDEBAR_RESOURCE':
            return Object.assign({}, state, {
                isLoading: !action.data.silent || state.isLoading,
                error: false,
                errorMessage: null
            });
        case 'DONE_GET_SIDEBAR_RESOURCE':
            return Object.assign({}, state, {
                data: action.data,
                isLoading: (action.data.silent ? state.isLoading : false),
                error: false,
                errorMessage: null
            });
        case 'ERROR_GET_SIDEBAR_RESOURCE':
            return Object.assign({}, state, {
                data: null,
                isLoading: false,
                error: true,
                errorMessage: action.data
            });
        case 'CREATE_SIDEBAR_RESOURCE':
            return Object.assign({}, state, {
                create: null,
                isLoading: true,
                error: false,
                errorMessage: null
            });
        case 'DONE_CREATE_SIDEBAR_RESOURCE':
            return Object.assign({}, state, {
                create: action.data,
                isLoading: false,
                error: false,
                errorMessage: null
            });
        case 'ERROR_CREATE_SIDEBAR_RESOURCE':
            return Object.assign({}, state, {
                create: null,
                isLoading: false,
                error: true,
                errorMessage: action.data
            });
        case 'UPDATE_SIDEBAR_RESOURCE':
            return Object.assign({}, state, {
                update: null,
                isLoading: true,
                error: false,
                errorMessage: null
            });
        case 'DONE_UPDATE_SIDEBAR_RESOURCE':
            return Object.assign({}, state, {
                update: true,
                isLoading: false,
                error: false,
                errorMessage: null
            });
        case 'ERROR_UPDATE_SIDEBAR_RESOURCE':
            return Object.assign({}, state, {
                update: null,
                isLoading: false,
                error: true,
                errorMessage: action.data
            });
        case 'DELETE_SIDEBAR_RESOURCE':
            return Object.assign({}, state, {
                deleteResource: null,
                isLoading: true,
                error: false,
                errorMessage: null
            });
        case 'DONE_DELETE_SIDEBAR_RESOURCE':
            return Object.assign({}, state, {
                deleteResource: true,
                isLoading: false,
                error: false,
                errorMessage: null
            });
        case 'ERROR_DELETE_SIDEBAR_RESOURCE':
            return Object.assign({}, state, {
                deleteResource: null,
                isLoading: false,
                error: true,
                errorMessage: action.data
            });
        case 'RESET_SIDEBAR_RESOURCE_MESSAGE':
            return Object.assign({}, state, {
                deleteResource: null,
                update: null,
                create: null,
                error: false,
                errorMessage: null
            });
        default:
            return state;
    }
};

export default sidebarResourceReducer;